import { AvailableLanguages } from 'context/TranslationContext/utils';

export const languagesItems = [
  {
    lang: AvailableLanguages.EN,
    flag: '/flags/gb.svg',
    text: 'English',
  },
  {
    lang: AvailableLanguages.RU,
    flag: '/flags/ru.svg',
    text: 'Russian',
  },
  {
    lang: AvailableLanguages.FR,
    flag: '/flags/fr.svg',
    text: 'Français',
  },
];
